import { jsx as _jsx } from "react/jsx-runtime";
import { useThemeConfig } from "../themeConfigContext";
import { GridSection } from "./gridSection";
export default function TextTypographySection(_a) {
    var t = useThemeConfig().t;
    return (_jsx(GridSection, { rows: [
            [
                {
                    title: "Label",
                    label: t("LBL_REL_LABEL", { ns: "ModuleBuilder" }) || "Label",
                    font: true,
                },
            ],
            [
                {
                    title: "Text content",
                    label: t("LBL_TEXT_BODY", { ns: "Emails" }) || "Text body",
                    font: true,
                },
            ],
            [
                {
                    title: "Url",
                    label: "Url",
                    font: true,
                    opacity: false,
                },
                {
                    title: "Url visited",
                    label: t("app.LBL_URL_VISITED", { ns: "common" }) || "Url visited",
                    font: true,
                    opacity: false,
                },
            ],
            [
                {
                    title: "Input text",
                    label: t("app.LBL_INPUT_TEXT", { ns: "common" }) || "Input text",
                    font: true,
                    opacity: false,
                },
                {
                    title: "Facelift text",
                    label: t("LBL_FACELIFT_TEXT", { ns: "Administration" }) ||
                        "Facelift text",
                    font: true,
                    opacity: false,
                },
            ],
        ] }));
}
